<ng-container *ngIf="!isHasEsOcrRedesign">
  <div class="view-invoice-right-info-main-top">
    <div class="view-invoice-info-box view-invoice-info-box-half">
      <div class="view-invoice-info-box-inner">
        <div class="view-invoice-info-box-header">
          <div class="view-invoice-info-box-header-text">{{ "INVOICE_MAIN_DETAILS" | translate }}</div>
          <div class="view-invoice-info-box-header-action" *ngIf="canEditInvoiceDetails ?? isEditable" (click)="editInvoice.emit()">
            <img class="view-invoice-info-box-header-action-icon" src="/assets/icons/icon_pencil_gray.svg" />
          </div>
        </div>

        <div class="view-invoice-info-box-body">
          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.INVOICE_NUMBER" | translate }}</div>
            <div class="view-invoice-info-box-body-value" *ngIf="invoice.invoiceNumber; else missingInfo">
              {{ invoice.invoiceNumber }}
            </div>
          </div>

          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.CURRENCY" | translate }}</div>
            <div class="view-invoice-info-box-body-value" *ngIf="invoice.currency; else missingInfo">{{ invoice.currency }}</div>
          </div>

          <div class="view-invoice-info-box-body-row" *ngIf="!!invoice.incoTermsCode">
            <div class="view-invoice-info-box-body-label">{{ "INCOTERMS_OPTIONAL" | translate }}</div>
            <div class="view-invoice-info-box-body-value">{{ getIncotermName }} ({{ invoice.incoTermsCode }})</div>
          </div>

          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.COUNTRY_OF_EXPORT" | translate }}</div>
            <div class="view-invoice-info-box-body-value" *ngIf="invoice?.countryOfExport?.description; else missingInfo">
              {{ invoice?.countryOfExport?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="view-invoice-info-box view-invoice-info-box-half">
      <div class="view-invoice-info-box-inner">
        <div class="view-invoice-info-box-header">
          <div
            class="view-invoice-info-box-header-text"
            [ngClass]="{ 'text-error': isAnyManufacturerFieldsInvalid || isManufacturerExpectedFromCanada }"
          >
            {{ "MANUFACTURER" | translate }}
          </div>
          <div class="view-invoice-info-box-header-action" *ngIf="canEditManufacturer ?? isEditable" (click)="editMF.emit()">
            <img class="view-invoice-info-box-header-action-icon" src="/assets/icons/icon_pencil_gray.svg" />
          </div>
        </div>

        <div class="view-invoice-info-box-body">
          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.NAME" | translate }}</div>
            <div class="view-invoice-info-box-body-value" *ngIf="invoice?.manufacturer?.name; else missingInfo">
              {{ invoice?.manufacturer?.name }}
            </div>
          </div>

          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.ADDRESS" | translate }}</div>
            <div class="view-invoice-info-box-body-value" *ngIf="invoice?.manufacturer?.address; else missingInfo">
              <ng-container *ngIf="isValidEntityAddress; else missingInfo">
                <address-details [address]="invoice.manufacturer.address"></address-details>
              </ng-container>
            </div>
          </div>

          <div class="manufacturer-canadian-hint text-error" *ngIf="isManufacturerExpectedFromCanada">
            {{ "BACK_ERROR.MANUFACTURER_EXPECTED_TO_BE_CANADIAN" | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="view-invoice-right-info-main-bottom">
    <div class="view-invoice-additional-info-column view-invoice-additional-info-column-four">
      <div class="view-invoice-additional-info-column-label">{{ "LABELS.ENTERED_VALUE" | translate }}</div>
      <div class="view-invoice-additional-info-column-value">
        <span>
          {{ (!!totalEnteredValueInUSD ? totalEnteredValueInUSD : totalEnteredValue) | currency }}
        </span>
        <span class="view-invoice-additional-info-column-value-secondary" *ngIf="totalEnteredValueInUSD !== totalEnteredValue">
          ({{ totalEnteredValue | currency : "" : "" : "1.2-2" }} {{ invoice.currency }})
        </span>
      </div>
    </div>

    <div class="view-invoice-additional-info-column view-invoice-additional-info-column-four">
      <div class="view-invoice-additional-info-column-label">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
      <div class="view-invoice-additional-info-column-value">
        {{ totalGrossWeight | number : "1.2-2" }} {{ "WEIGHT_UNIT.KG" | translate }}
      </div>
    </div>

    <div class="view-invoice-additional-info-column view-invoice-additional-info-column-four">
      <div class="view-invoice-additional-info-column-label">{{ "LABELS.NUM_OF_LINES" | translate }}</div>
      <div class="view-invoice-additional-info-column-value">
        {{ invoice?.lines?.length }}
      </div>
    </div>

    <div class="view-invoice-additional-info-column view-invoice-additional-info-column-four">
      <button
        type="button"
        class="view-invoice-additional-info-column-btn"
        *ngIf="isShowCollapse"
        (click)="isOpenedItems ? closeItems.emit() : openItems.emit()"
      >
        <span class="view-invoice-additional-info-column-btn-inner">
          <span class="view-invoice-additional-info-column-btn-icon">
            <img src="/assets/icons/icon_eye.svg" class="view-invoice-additional-info-column-btn-icon-img" />
          </span>
          <span>{{ (isOpenedItems ? "BUTTON.CLOSE" : "OPEN_ALL_ITEMS") | translate }}</span>
        </span>
      </button>

      <ng-container *ngIf="isEditable || canDeleteInvoice || canEditLineItems || canClearInvoice">
        <ng-container *ngTemplateOutlet="dropdown"></ng-container>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="isHasEsOcrRedesign">
  <div class="view-invoice-right-info-main-top redesign">
    <div class="view-invoice-right-info-main-top__left">
      <div class="view-invoice-additional-info-column redesign view-invoice-additional-info-column-four m-0">
        <div class="view-invoice-additional-info-column-label">{{ "LABELS.ENTERED_VALUE" | translate }}</div>
        <div class="view-invoice-additional-info-column-value">
          <span>
            {{ (!!totalEnteredValueInUSD ? totalEnteredValueInUSD : totalEnteredValue) | currency }}
          </span>
          <span class="view-invoice-additional-info-column-value-secondary" *ngIf="totalEnteredValueInUSD !== totalEnteredValue">
            ({{ totalEnteredValue | currency : "" : "" : "1.2-2" }} {{ invoice.currency }})
          </span>
        </div>
      </div>

      <div class="view-invoice-additional-info-column redesign view-invoice-additional-info-column-four m-0">
        <div class="view-invoice-additional-info-column-label">{{ "LABELS.GROSS_WEIGHT" | translate }}</div>
        <div class="view-invoice-additional-info-column-value">
          {{ totalGrossWeight | number : "1.2-2" }} {{ "WEIGHT_UNIT.KG" | translate }}
        </div>
      </div>

      <div class="view-invoice-additional-info-column redesign view-invoice-additional-info-column-four m-0">
        <div class="view-invoice-additional-info-column-label">{{ "LABELS.NUM_OF_LINES" | translate }}</div>
        <div class="view-invoice-additional-info-column-value">
          {{ invoice?.lines?.length }}
        </div>
      </div>
    </div>

    <div class="view-invoice-additional-info-column redesign view-invoice-additional-info-column-four">
      <button
        type="button"
        class="view-invoice-additional-info-column-btn"
        *ngIf="isShowCollapse"
        (click)="isOpenedItems ? closeItems.emit() : openItems.emit()"
      >
        <span class="view-invoice-additional-info-column-btn-inner">
          <span class="view-invoice-additional-info-column-btn-icon">
            <img src="/assets/icons/icon_eye.svg" class="view-invoice-additional-info-column-btn-icon-img" />
          </span>
          <span>{{ (isOpenedItems ? "BUTTON.CLOSE" : "OPEN_ALL_ITEMS") | translate }}</span>
        </span>
      </button>

      <ng-container *ngIf="isEditable || canDeleteInvoice || canEditLineItems || canClearInvoice">
        <ng-container *ngTemplateOutlet="dropdown"></ng-container>
      </ng-container>
    </div>
  </div>

  <div class="view-invoice-right-info-main-bottom">
    <div class="view-invoice-info-box redesign view-invoice-info-box-half">
      <div class="view-invoice-info-box-inner">
        <div class="view-invoice-info-box-header">
          <div class="view-invoice-info-box-header-text" [ngClass]="{ 'text-error': isAnyInvoiceMainFieldsInvalid }">
            {{ "INVOICE_MAIN_DETAILS" | translate }}
          </div>
          <div class="view-invoice-info-box-header-action" *ngIf="canEditInvoiceDetails ?? isEditable" (click)="editInvoice.emit()">
            <img class="view-invoice-info-box-header-action-icon" src="/assets/icons/icon_pencil_gray.svg" />
          </div>
        </div>

        <div class="view-invoice-info-box-body">
          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.INVOICE_NUMBER" | translate }}</div>
            <div class="view-invoice-info-box-body-value">
              {{ !invoice.invoiceNumber ? "-----" : invoice.invoiceNumber }}
            </div>
          </div>

          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.CURRENCY" | translate }}</div>
            <div class="view-invoice-info-box-body-value">
              {{ !invoice.currency ? "-----" : invoice.currency }}
            </div>
          </div>

          <div class="view-invoice-info-box-body-row" *ngIf="!!invoice.incoTermsCode">
            <div class="view-invoice-info-box-body-label">{{ "INCOTERMS_OPTIONAL" | translate }}</div>
            <div class="view-invoice-info-box-body-value">{{ getIncotermName }} ({{ invoice.incoTermsCode }})</div>
          </div>

          <div class="view-invoice-info-box-body-row">
            <div class="view-invoice-info-box-body-label">{{ "LABELS.COUNTRY_OF_EXPORT" | translate }}</div>
            <div class="view-invoice-info-box-body-value">
              {{ !invoice?.countryOfExport?.description ? "-----" : invoice?.countryOfExport?.description }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="view-invoice-info-box redesign view-invoice-info-box-half">
      <div class="view-invoice-info-box-inner" [ngClass]="{ 'missing-field-info-box-inner': isAllManufacturerFieldsInvalid }">
        <div class="view-invoice-info-box-header">
          <div
            class="view-invoice-info-box-header-text"
            [ngClass]="{ 'text-error': isAnyManufacturerFieldsInvalid || isManufacturerExpectedFromCanada }"
          >
            {{ "MANUFACTURER" | translate }}
          </div>
          <div
            class="view-invoice-info-box-header-action"
            *ngIf="(canEditManufacturer ?? isEditable) && !isAllManufacturerFieldsInvalid"
            (click)="editMF.emit()"
          >
            <img class="view-invoice-info-box-header-action-icon" src="/assets/icons/icon_pencil_gray.svg" />
          </div>
        </div>

        <div class="view-invoice-info-box-body" [ngClass]="{ 'missing-field-body': isAllManufacturerFieldsInvalid }">
          <div *ngIf="isAllManufacturerFieldsInvalid && (canEditManufacturer ?? isEditable)" class="view-invoice-info-box__missing-fields">
            <div class="view-invoice-info-box__missing-fields__edit-button" (click)="editMF.emit()">
              <img class="view-invoice-info-box__missing-fields__edit-button__icon" src="assets/icons/icon_edit_gray_md.svg" alt="edit" />
            </div>
          </div>

          <ng-container *ngIf="!isAllManufacturerFieldsInvalid">
            <div class="view-invoice-info-box-body-row">
              <div class="view-invoice-info-box-body-label">{{ "LABELS.NAME" | translate }}</div>
              <div class="view-invoice-info-box-body-value">
                {{ !invoice?.manufacturer?.name ? "-----" : invoice?.manufacturer?.name }}
              </div>
            </div>

            <div class="view-invoice-info-box-body-row">
              <div class="view-invoice-info-box-body-label">{{ "LABELS.ADDRESS" | translate }}</div>

              <div class="view-invoice-info-box-body-value" *ngIf="invoice?.manufacturer?.address && isValidEntityAddress">
                <address-details [address]="invoice.manufacturer.address"></address-details>
              </div>

              <div class="view-invoice-info-box-body-value" *ngIf="!invoice?.manufacturer?.address || !isValidEntityAddress">-----</div>
            </div>

            <div class="manufacturer-canadian-hint text-error" *ngIf="isManufacturerExpectedFromCanada">
              {{ "BACK_ERROR.MANUFACTURER_EXPECTED_TO_BE_CANADIAN" | translate }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #missingInfo>
  <div class="view-invoice-info-box-body-value-missing">{{ "LABELS.MISSING" | translate }}</div>
</ng-template>

<ng-template #dropdown>
  <div class="view-invoice-menu" dropdown container="body" placement="bottom right">
    <button
      id="invoice-menu-{{ invoice.id }}"
      dropdownToggle
      type="button"
      class="btn btn-link dropdown-toggle view-invoice-menu-btn rounded-circle"
    >
      <i class="fa fa-ellipsis-h"></i>
    </button>
    <ul id="invoice-dropdown-{{ invoice.id }}" class="view-invoice-menu-list" role="menu" *dropdownMenu>
      <li role="menuitem" class="cursor-pointer" *ngIf="canEditLineItems ?? isEditable" (click)="addLineItem.emit()">
        <div class="view-invoice-menu-item">
          <div class="view-invoice-menu-item-img-container">
            <img src="assets/icons/icon_plus_circle.svg" class="view-invoice-menu-item-img view-invoice-menu-item-img-add" />
          </div>
          <span>{{ "ADD_ANOTHER_LINE_ITEM" | translate }}</span>
        </div>
      </li>
      <li role="menuitem" class="cursor-pointer" *ngIf="isEditable" (click)="inputElementClick.emit()">
        <div class="view-invoice-menu-item">
          <div class="view-invoice-menu-item-img-container">
            <img src="assets/icons/icon_sync.svg" class="view-invoice-menu-item-img view-invoice-menu-item-img-replace" />
          </div>
          <span>{{ "REPLACE_INVOICE" | translate }}</span>
        </div>
      </li>
      <li role="menuitem" class="cursor-pointer" *ngIf="canDeleteInvoice ?? isEditable" (click)="deleteInvoice.emit()">
        <div class="view-invoice-menu-item">
          <div class="view-invoice-menu-item-img-container">
            <img src="assets/icons/trash_gray.svg" class="view-invoice-menu-item-img view-invoice-menu-item-img-delete" />
          </div>
          <span>{{ "BUTTON.DELETE_INVOICE" | translate }}</span>
        </div>
      </li>
      <li role="menuitem" class="cursor-pointer" *ngIf="canClearInvoice ?? isEditable" (click)="clearData.emit()">
        <div class="view-invoice-menu-item">
          <div class="view-invoice-menu-item-img-container">
            <img src="assets/icons/icon_pencil_gray.svg" class="view-invoice-menu-item-img view-invoice-menu-item-img-clear" />
          </div>
          <span>{{ "CLEAR_DATA_AND_ENTER_MANUALLY" | translate }}</span>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
